import { render, staticRenderFns } from "./ModalSinInternet.vue?vue&type=template&id=51387daa"
import script from "./ModalSinInternet.vue?vue&type=script&lang=js"
export * from "./ModalSinInternet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports